import { StudentAssessmentType } from "../../../types/Assessment";
import { PagedRequestType, PagedResultsType } from "../../../types/PagedResults";
import { StudentDocumentType } from "../../../types/Student";
import { get } from "../../../utils/axios-config";
import { STUDENT_DOCUMENTS } from "../../../utils/constants";

export const getStudentDocuments = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdClass ? { IdClass: data.IdClass } : {}),
        ...(data?.IdSubject ? { IdSubject: data.IdSubject } : {}),
        ...(data?.IdTeacher ? { IdTeacher: data.IdTeacher } : {}),
        ...(data?.IdStudent ? { IdStudent: data.IdStudent } : {}),
        ...(data?.State ? { State: data.State } : {}),
        ...(data?.DocType ? { DocType: data.DocType } : {}),
    });
    if(data?.IsPayed !== null  && data?.IsPayed !== undefined){
        queryParams.append("IsPayed", String(data?.IsPayed));
    }
    const url = `${STUDENT_DOCUMENTS}?${queryParams.toString()}`;
    return await get<PagedResultsType<StudentDocumentType>>(url)
};